import { create } from 'zustand';
import { Product, CartItem } from '../types';

interface StoreState {
  cart: CartItem[];
  cartCount: number;
  addToCart: (product: Product) => void;
  removeFromCart: (itemId: number) => void;
  updateQuantity: (itemId: number, quantity: number) => void;
  clearCart: () => void;
  setCart: (cart: CartItem[]) => void;
  calculateTotal: () => number;
}

export const useStore = create<StoreState>((set, get) => ({
  cart: [],
  cartCount: 0,

  addToCart: (product) => {
    const { cart } = get();
    const existingItem = cart.find(item => item.productId === product.id);

    if (existingItem) {
      set({
        cart: cart.map(item =>
          item.productId === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        ),
      });
    } else {
      set({
        cart: [
          ...cart,
          {
            id: Date.now(),
            userId: '',
            productId: product.id,
            quantity: 1,
            product,
          },
        ],
      });
    }

    set({ cartCount: get().cart.reduce((sum, item) => sum + item.quantity, 0) });
  },

  removeFromCart: (itemId) => {
    set({
      cart: get().cart.filter(item => item.id !== itemId),
    });
    set({ cartCount: get().cart.reduce((sum, item) => sum + item.quantity, 0) });
  },

  updateQuantity: (itemId, quantity) => {
    if (quantity <= 0) {
      get().removeFromCart(itemId);
      return;
    }

    set({
      cart: get().cart.map(item =>
        item.id === itemId ? { ...item, quantity } : item
      ),
    });
    set({ cartCount: get().cart.reduce((sum, item) => sum + item.quantity, 0) });
  },

  clearCart: () => {
    set({ cart: [], cartCount: 0 });
  },

  setCart: (cart) => {
    set({
      cart,
      cartCount: cart.reduce((sum, item) => sum + item.quantity, 0),
    });
  },

  calculateTotal: () => {
    return get().cart.reduce(
      (sum, item) => sum + parseFloat(item.product.price) * item.quantity,
      0
    );
  },
}));
